export default {
  timezones: [],
  assetKinds: []
}